import { resolveColorsToken } from '../../helpers/color-utils';
export const shadowScroll = (theme) => {
    const color = theme.colors ? resolveColorsToken(theme.colors, 'foreground.subtle') : 'transparent';
    return {
        before: {
            base: {
                content: '""',
                position: 'absolute',
                zIndex: 1,
                bottom: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                transition: 'box-shadow 0.3s ease-in-out',
            },
            visible: {
                boxShadow: `0 -12px 8px -12px ${color} inset`,
            },
            hidden: {
                boxShadow: 'none',
            },
        },
    };
};
//# sourceMappingURL=shadow-scroll.js.map